<template>
  <div
    class="h-screen flex w-full bg-img p-fix vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 login-max-w sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color back-grey">
          <div class="vx-row no-gutter justify-center items-center">
            <div
              class="vx-col hidden xl:block lg:w-1/2 px-4 py-10 color-bg-login min-h-login"
            >
              <img
                class="mb-5 max-w-logo d-block m-auto"
                src="@/assets/images/logo/logo-full.svg"
                alt="registerImg"
              />
              <img
                src="@/assets/images/pages/workspace.svg"
                alt="workspace"
                class="mx-auto"
              />
            </div>

            <div
              class="vx-col md:w-full lg:w-full xl:w-1/2 xl d-theme-dark-bg min-h-company"
            >
              <div class="p-8 lg:mt-5 login-tabs-container py-login">
                <div class="vx-card__title">
                  <h4 class="mb-4 font-w-600">Crea una Carpeta de Trabajo</h4>
                  <p>
                    Puedes crear
                    <span class="font-w-600">Carpetas de Trabajo</span> para
                    organizar tus documentos e invitar a determinados usuarios a
                    colaborar en estas.
                  </p>
                </div>

                <div>
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <vs-input
                        label="Crea una Carpeta de Trabajo"
                        :placeholder="placeholder"
                        name="razon_social"
                        autocomplete="off"
                        v-model="razon_social"
                        @input="razon_social = $event.toUpperCase()"
                        class="w-full"
                      />
                    </div>
                  </div>

                  <!-- Checkbox para mostrar el control de selección de imagen -->
                  <vs-checkbox
                    v-model="showLogoSelector"
                    class="mt-6 d-inline-b"
                  >
                    Seleccionar un logo para la carpeta de trabajo ahora
                  </vs-checkbox>

                  <!-- Control de selección de imagen que se muestra condicionalmente -->
                  <div class="upload-img mt-2" v-if="showLogoSelector">
                    <div class="p-4">
                      <input
                        type="file"
                        ref="fileInputLogo"
                        class="hidden"
                        accept="image/*"
                        @change="handleClickLogo"
                      />
                      <div class="excel-import" v-if="!croppedImg">
                        <div
                          @click="$refs.fileInputLogo.click()"
                          @drop="handleDropLogo"
                          @dragover="handleDragoverLogo"
                          @dragenter="handleDragoverLogo"
                          class="px-8 py-6 cursor-pointer text-center border-2 border-dashed d-theme-border-grey-light d-theme-dark-bg text-xl"
                        >
                          <feather-icon
                            icon="UploadCloudIcon"
                            svgClasses="h-16 w-16 stroke-current text-grey"
                            class="block"
                          />
                          <div v-if="!dataImgToShow">
                            <span>Arrastra o </span>
                            <span
                              class="font-medium text-primary"
                              @click.stop="$refs.fileInputLogo.click()"
                            >selecciona tu logo</span
                            >
                          </div>
                          <span class="block" v-else
                          ><b>{{ dataImgToShow.name }}</b></span
                          >
                        </div>
                      </div>

                      <vx-input-group class="mt-6 text-center" v-else>
                        <img
                          class="mx-auto"
                          :src="urlCroppedImg"
                          alt="logoCropped"
                        />
                        <br />
                        <vs-button type="border" @click="$refs.fileInputLogo.click()"
                        >Cambiar imagen</vs-button
                        >
                      </vx-input-group>

                      <p class="text-primary mt-3">
                        El formato requerido es de 300 ancho x 100 alto píxeles
                        <vx-tooltip
                          text="Más información acerca del logo"
                          class="d-inline-block"
                          position="top"
                        >
                          <feather-icon
                            @click="popupActive = true"
                            icon="HelpCircleIcon"
                            class="float top-3 text-primary"
                            svgClasses="w-4 h-4"
                          ></feather-icon>
                        </vx-tooltip>
                      </p>
                    </div>
                  </div>

                  <!-- Botón Guardar -->
                  <vs-button
                    class="float-right mb-5 mt-4"
                    :disabled="isSubmitted"
                    @click="submitForm"
                  >Guardar</vs-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>

    <!-- Popups existentes -->
    <vs-popup title="Especificaciones de logo" :active.sync="popupActive">
      <p>
        Personaliza tus documentos firmados con tu marca (solo Plan Profesional
        y Corporativo), es necesario que cumpla las siguientes especificaciones:
        300 ancho x 100 alto píxeles. Descargar plantilla
        <a href="/files/AI.ai" target="_blank" download><b>AI</b></a>,
        <a href="/files/PSD.psd" target="_blank" download><b>PSD</b></a> o
        <a href="/files/png.png" target="_blank" download><b>PNG</b></a>.
      </p>
    </vs-popup>

    <vs-popup
      :button-close-hidden="true"
      title="Ajusta tu logo"
      :active.sync="popupLogoAdjust"
    >
      <cropper-logo
        v-if="popupLogoAdjust"
        :close-popup-logo-adjust="closePopupLogoAdjust"
        :load-img="loadImg"
        :data-img="dataImg"
        :set-cropped-img="setCroppedImg"
        :set-data-img-to-show="setDataImgToShow"
      ></cropper-logo>
    </vs-popup>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import router from '@/router';
import vSelect from 'vue-select';
import { mapState } from 'vuex';
import CropperLogo from '@/views/pages/configuration/companies/components/CropperLogo';

export default {
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    CropperLogo,
  },
  data() {
    return {
      popupLogoAdjust: false,
      popupActive: false,
      razon_social: null,
      dataImg: null,
      dataImgToShow: null,
      isSubmitted: false,
      loadImg: null,
      croppedImg: null,
      showLogoSelector: false, // Nueva propiedad para controlar el checkbox
    };
  },
  computed: {
    ...mapState({
      user: function (state) {
        return state.account.user;
      },
      urlCroppedImg() {
        return URL.createObjectURL(this.croppedImg);
      },
    }),
    placeholder() {
      return (
        'Ejemplo: "Verificamex" o "' +
        this.user.me.name.split(' ')[0] +
        ' ' +
        this.user.me.last_name.split(' ')[0] +
        '"'
      );
    },
  },
  methods: {
    setDataImgToShow(dataImg) {
      this.dataImgToShow = dataImg;
    },
    setCroppedImg(croppedImg) {
      this.croppedImg = croppedImg;
    },
    closePopupLogoAdjust() {
      this.popupLogoAdjust = false;
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    submitForm() {
      this.$store.dispatch('alert/clear', {}, { root: true });
      if (!this.razon_social) {
        this.$store.dispatch('alert/error', 'Ingresa los datos solicitados', {
          root: true,
        });
        return;
      }
      this.isSubmitted = true;

      const companyData = {
        name: this.razon_social,
      };

      // Solo añadir el logo si está disponible y el usuario ha seleccionado subirlo
      if (this.showLogoSelector && this.croppedImg) {
        companyData.logo = this.croppedImg;
      }

      this.$store
        .dispatch('companies/createCompany', {
          company: companyData,
          aclChangeRole: this.$acl.change,
        })
        .then(
          () => {
            router.push('/');
          },
          (error) => {
            this.isSubmitted = false;
            router.push('/');
          }
        );
    },
    handleDragoverLogo(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
    },
    handleDropLogo(e) {
      e.stopPropagation();
      e.preventDefault();
      const files = e.dataTransfer.files;
      if (files.length !== 1) {
        this.$vs.notify({
          title: 'Subir',
          text: 'Solo puedes subir un archivo',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
        return;
      }
      const rawFile = files[0]; // only use files[0]
      this.uploadFileLogo(rawFile);
    },
    handleClickLogo(e) {
      const files = e.target.files;
      const rawFile = files[0];
      if (!rawFile) return;
      this.uploadFileLogo(rawFile);
    },
    uploadFileLogo(file) {
      this.$store.dispatch('alert/clear', {});
      this.$refs['fileInputLogo'].value = null;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.dataImg = file;
        this.loadImg = e.target.result;
        this.popupLogoAdjust = true;
      };
      reader.readAsDataURL(file);
    },
    cropImage() {
      this.$store.dispatch('alert/clear', {});
      this.$refs.cropper
        .getCroppedCanvas({
          width: 300,
          height: 100,
        })
        .toBlob((blob) => {
          this.dataImg = this.loadImg;
          this.croppedImg = blob;
          this.popupLogoAdjust = false;
          this.$store.dispatch(
            'alert/success',
            'Recortaste la imagen con éxito'
          );
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
.p-fix {
  position: fixed;
}
</style>
